<template>
  <span :class="className">
    {{ t(nameMap[status]) }}
  </span>
</template>

<script setup lang="ts">
import { defineOptions, computed } from 'vue'
import { useTypedI18n, i18nkey } from '@/functions/useTypedI18n'

type Status = string | number
type NameMap = Record<Status, i18nkey>
type ColorMap = Record<Status, string>

defineOptions({
  name: 'BaseStatus'
})

const props = withDefaults(defineProps<{
  nameMap: NameMap,
  status: Status,
  colorMap?: ColorMap
}>(), {
  colorMap: undefined
})

const { t } = useTypedI18n()
const className = computed(() => {
  if (props.colorMap) return props.colorMap[props.status]
  return ''
})
</script>
